// Formattazione dei valori restituiti dalle query dei widget.
// Il tipo di ogni colonna viene dedotto dai dati, perche' la query e' SQL libera.

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/
const DATETIME_RE = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?/
const NUMBER_RE = /^-?\d+(\.\d+)?$/
const HTML_RE = /<\/?[a-z][^>]*>/i
// Colonne numeriche da non formattare con il separatore delle migliaia (codici, telefoni, id...)
const CODE_NAME_RE = /(^|[_\s])(id|cod|codice|code|tel|telefono|phone|cell|cellulare|cap|zip|iva|piva|cf|anno|year|matricola|numero|num)([_\s]|$)/i
const TOTAL_NAME_RE = /^(tot|totale|totali|total|totals)$/i

const numberFormat = new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })
const currencyFormats = {}

// Formato valuta (es. 'EUR' -> "1.234,50 €"), creato una volta per codice.
// null se il codice non è valido o il browser non lo supporta: si ripiega sul numero semplice
function currencyFormat(currency) {
    if (!(currency in currencyFormats)) {
        try {
            currencyFormats[currency] = new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency,
                currencyDisplay: 'narrowSymbol',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        } catch (e) {
            currencyFormats[currency] = null
        }
    }
    return currencyFormats[currency]
}

function escapeHtml(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
}

function pad(n) {
    return n < 10 ? '0' + n : String(n)
}

// Input:  nomi colonne e righe
// Output: { colonna: 'number' | 'date' | 'datetime' | 'html' | 'text' }
export function detectColumnTypes(columns, rows) {
    const types = {}
    const sample = (rows || []).slice(0, 200)

    columns.forEach(col => {
        const values = sample.map(r => r[col]).filter(v => v !== null && v !== undefined && v !== '')
        if (!values.length) {
            types[col] = 'text'
            return
        }
        if (values.some(v => typeof v === 'string' && HTML_RE.test(v))) {
            types[col] = 'html'
        } else if (values.every(v => typeof v === 'string' && DATETIME_RE.test(v))) {
            types[col] = 'datetime'
        } else if (values.every(v => typeof v === 'string' && DATE_RE.test(v))) {
            types[col] = 'date'
        } else if (
            !CODE_NAME_RE.test(col)
            && values.every(v => typeof v === 'number' || (typeof v === 'string' && NUMBER_RE.test(v) && v.length < 16))
        ) {
            types[col] = 'number'
        } else {
            types[col] = 'text'
        }
    })

    return types
}

export function isTotalColumn(name) {
    return TOTAL_NAME_RE.test(String(name).trim())
}

// currency: codice valuta del widget (chart_config.currency), es. 'EUR'; vuoto = numero semplice
export function formatNumber(value, currency) {
    const n = typeof value === 'number' ? value : parseFloat(value)
    if (isNaN(n)) return String(value)
    return ((currency && currencyFormat(currency)) || numberFormat).format(n)
}

// Simbolo della valuta per i formati amCharts, es. 'EUR' -> '€'
export function currencySymbol(currency) {
    const format = currencyFormat(currency)
    const part = format && format.formatToParts(0).find(p => p.type === 'currency')
    return part ? part.value : currency
}

function formatDate(value, withTime) {
    const d = new Date(value.replace(' ', 'T'))
    if (isNaN(d.getTime())) return value
    const date = pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear()
    return withTime ? date + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) : date
}

// Output: stringa HTML pronta per v-html (il testo semplice viene escapato)
export function formatCell(value, type, currency) {
    if (value === null || value === undefined || value === '') return ''
    switch (type) {
    case 'number':
        return escapeHtml(formatNumber(value, currency))
    case 'date':
        return escapeHtml(formatDate(String(value), false))
    case 'datetime':
        return escapeHtml(formatDate(String(value), true))
    case 'html':
        return String(value)
    default:
        return escapeHtml(value)
    }
}

// Testo per il CSV: numeri e date restano grezzi, l'HTML viene ridotto a testo
export function plainCell(value, type) {
    if (value === null || value === undefined) return ''
    if (type === 'html') {
        return String(value).replace(/<[^>]*>/g, '').trim()
    }
    return value
}
